import script from "./UserHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserHome.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__